import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ISalesInvoiceReportGetAllParams } from "@api/stores/salesInvoiceReport/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  ISalesInvoiceReportGetAllParams
>("stores.salesInvoiceReport.exportExcel");

export const exportExcel = {
  ...getApis,
};
